import { LightShowOperation } from '../Operations/lightshow-operation';
import { LightshowSegmentTypes } from './lightshow-segment-types';
import { LightShowSegment } from './lightshow-segment';

/**
 * Lightshow segments do not correspond 1:1 with operations. For example, a color segment
 * will generate 1 set-color operation on every torch/strobe start.
 */
export class BlankSegment extends LightShowSegment {

  public init(): void {

    this.segmentType = LightshowSegmentTypes.Unknown;
    this.minDuration = 200;
    this.color = 'black';
    this.enableSegmentGrips = true;
  }

  public addOperations(operations: LightShowOperation[]): void {};
}